import { render, staticRenderFns } from "./HistorySecondYear.vue?vue&type=template&id=22231410&"
import script from "./HistorySecondYear.vue?vue&type=script&lang=ts&"
export * from "./HistorySecondYear.vue?vue&type=script&lang=ts&"
import style0 from "./HistorySecondYear.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AnimateExpand: require('/Users/markussh/git/theodora-tech-website/src/components/animate/AnimateExpand.vue').default,IconPlus: require('/Users/markussh/git/theodora-tech-website/src/components/icon/Plus.vue').default,Button: require('/Users/markussh/git/theodora-tech-website/src/components/button/Button.vue').default})
